module.exports = __webpack_public_path__ + "static/media/sidebar_zigaretten.80a6dc3d.jpg";